// Method to getting player state
export default function state(player) {
  return {
    playing: !player.paused(),
    volume: player.volume(),
    muted: player.muted(),
    currentTime: player.currentTime(),
    endTime: player.duration()
  };
}
